var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTxConfirmed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4186_48236)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66651 1.51473C4.94918 0.657677 6.45719 0.200216 7.99985 0.200195C10.0679 0.202461 12.0505 1.02498 13.5129 2.4873C14.9752 3.94964 15.7977 5.93235 15.8 8.00041C15.7999 9.54303 15.3425 11.051 14.4854 12.3336C13.6283 13.6163 12.4101 14.6161 10.9849 15.2065C9.55962 15.7968 7.9913 15.9513 6.47825 15.6503C4.9652 15.3494 3.57537 14.6065 2.48452 13.5156C1.39367 12.4248 0.650794 11.035 0.349829 9.5219C0.0488648 8.00885 0.203331 6.44053 0.793694 5.01526C1.38406 3.59 2.3838 2.37181 3.66651 1.51473ZM14.8666 8.0002C14.8666 6.6421 14.4639 5.3145 13.7094 4.18528C12.9549 3.05606 11.8824 2.17594 10.6277 1.65622C9.373 1.1365 7.99234 1.00052 6.66034 1.26547C5.32833 1.53042 4.10481 2.18441 3.14449 3.14473C2.18417 4.10505 1.53018 5.32857 1.26523 6.66057C1.00028 7.99258 1.13626 9.37324 1.65598 10.628C2.1757 11.8827 3.05582 12.9551 4.18504 13.7096C5.31426 14.4641 6.64186 14.8669 7.99995 14.8669C9.82044 14.8649 11.566 14.1408 12.8533 12.8535C14.1406 11.5662 14.8646 9.82068 14.8666 8.0002Z",
    fill: "#39C761"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4773 4.92511C11.7397 5.07816 11.8283 5.41494 11.6752 5.67732L8.75902 10.6766C8.28224 11.4939 7.19077 11.697 6.45188 11.1059L4.85658 9.82966C4.61939 9.63991 4.58093 9.2938 4.77069 9.0566C4.96044 8.81941 5.30655 8.78095 5.54375 8.97071L7.13905 10.2469C7.35356 10.4186 7.67044 10.3596 7.80886 10.1223L10.7251 5.12306C10.8781 4.86068 11.2149 4.77205 11.4773 4.92511Z",
    fill: "#39C761"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4186_48236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxConfirmed);
export default __webpack_public_path__ + "static/media/tx-confirmed.93c4ae1e165faa7c9a34d1f5b66d6772.svg";
export { ForwardRef as ReactComponent };